module.exports = __webpack_public_path__ + "img/carrusel_1.5c8111cf.svg";